import type {
    TApiUpload,
    TApiTask,
    TApiCheck,
    TUploadedFile,
    TApiUploadedFile,
    TUpload,
    TOneDriveResponse,
    TDropBoxResponse,
    TGoogleDriveResponse,
    TFilesDropBox,
    TFilesOneDrive,
    TFilesGoogleDrive,
    TPage,
    TThumbTask,
    TTaskData,
    TSign,
    TErase,
    TSignPlacer,
    TRect,
} from "./types"

import { 
    checkTimeout,
    apiURL,
    development,
 } from "./constants"

import {
    sendUploadFiles,
    sendTask,
    check,
    sendUploadLocal,
    sendUploadDropBox,
    sendUploadOneDrive,
    sendUploadGoogleDrive,
} from "./Send"

import { getPngB64, refreshUserUUID } from './helpers'
import { throwErrorScreen } from './screens/Error'

const rand = () => (Math.random() + 1).toString(36).substring(7)

const validate = (
    upload: TUpload,
    name: string,
    size: number,
) => {
    // return true
    const allowExtantions = upload.allowExtantions
    const maxSize = upload.maxSize
    const addError = upload.addError
    const getExt = (fileName: string) => {
        const ext = fileName.match(/\.([0-9a-z]{1,5})$/i)
        if (ext && ext[1]) return ext[1].toLowerCase()
        return null
    }

    const detail: string[] = []
    if (!allowExtantions.find(ext => ext === name.split('.')[name.split('.').length - 1].toLowerCase())) {
        detail.push('extension')
    }

    if ((size / 1024 / 1024) > maxSize) {
        detail.push('size')
    }

    if (detail.length != 0) {
        addError({
            filename: name,
            detail: detail,
            type_ext: getExt(name),
            rand: rand(),
        })
        return false
    }

    return true
}

const getCheckTimeout = (
    checkCounter: number,
) => {
    // checkCounter 0, 1, 2 ....
    // return Number ms
    return checkTimeout
}


const setUploadedFiles = (
    data: TApiUpload,
    upload: TUpload,
) => {
    if (data.status === "success" && data.files) {      
        let thumb_task: TThumbTask | undefined

        const uploaded: TUploadedFile[] = []
        data.files.map((apiUploadedFile: TApiUploadedFile) => {
            if (apiUploadedFile.status !== 'error' && apiUploadedFile.file_uuid) {
                uploaded.push({
                    filename: apiUploadedFile.filename,
                    file_uuid: apiUploadedFile.file_uuid,
                    type_ext: apiUploadedFile.type_ext,
                })

                if (apiUploadedFile.thumb_task_uuid) thumb_task = {
                    filename: apiUploadedFile.filename,
                    file_uuid: apiUploadedFile.file_uuid,
                    thumb_task_uuid: apiUploadedFile.thumb_task_uuid,
                }
            }
            else {
                upload.addError({
                    filename: apiUploadedFile.filename,
                    detail: apiUploadedFile.detail,
                    type_ext: apiUploadedFile.type_ext,
                    rand: rand(),
                })
            }
        })

        upload.addFiles(uploaded)

        if (thumb_task) return prepare({
            upload: upload,
            thumb_task: thumb_task,           
        })

        return upload.setScreen("filespreview")
    }
    else {
        return throwErrorScreen(upload, 'upload')
    }
}





export const filesUpload = ({
    files,
    upload,
}: {
    files: FileList,
    upload: TUpload,
}) => {
    const setScreen = upload.setScreen
    const filesArray: File[] = []
    Object.values(files).map((file: File, i: number) => {
        // для дропзоны скип если не мультиселект, тк FileList readOnly
        if (!upload.multiselect && i > 0) return false
        if (validate(upload, file.name, file.size)) return filesArray.push(file)
    })

    if (filesArray.length === 0) return false;

    setScreen("uploading")

    return sendUploadFiles(
        filesArray,
        upload.setProgress,
        upload.action,
    ).then(data => setUploadedFiles(data, upload)
    ).catch(() => throwErrorScreen(upload, 'catch'))
}


export const dspDocInfo = async (
    upload: TUpload,
    id: number,
    setSignBeacons: (beacons: {
        height: number,
        width: number,
        x: number,
        y: number,
    }[][]) => void,
    setAutoRects: (rects: TRect[]) => void,
) => {
    const setScreen = upload.setScreen
    const setPages = upload.setPages
    const setDefaultPages = upload.setDefaultPages
    if (!setPages || !setDefaultPages) {
        return;
    }   
    window.history.replaceState(null, '', window.location.pathname)
    setScreen("uploading")
    try {
        // девелоп закоменчен тк биконы пока не реализованы в девапи
        //@ts-ignore
        const apiUrl = dspInfoURL || ''
        const response = await fetch(`${apiUrl}/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
        })
        const data = await response.json()
        

        let pages: TPage[] = []

        const beacons: {
            height: number,
            width: number,
            x: number,
            y: number,
        }[][] = []

        const rects: {
            page: number,
            width: number,
            height: number,
            x: number,
            y: number,
        }[] = []

        data.pages.forEach((page: any) => {
            const pageItem: TPage = {
                page_num: page.num - 1 || 0,
                thumb_link: page.thumb || '',
                rotate: 0,
                file_flag: 0,
                huge_height: Number(page.height) || 0,
                huge_width: Number(page.width) || 0,
                huge_link: page.url || '',
            }

            if (page.forms) {
                page.forms.filter((form: any) => form.type === 'form-sig').forEach((formSig: any) => {
                    if (
                        typeof formSig.height === 'number'
                        && typeof formSig.width === 'number'
                        && typeof formSig.top === 'number'
                        && typeof formSig.left === 'number'
                    ) {
                        rects.push({
                            page: page.num - 1 || 0,
                            width: formSig.width,
                            height: formSig.height,
                            x: formSig.left,
                            y: formSig.top,
                        })
                    }
                });
            }

            beacons.push(page.sign_info || [])
            pages.push(pageItem)
        })

        setDefaultPages(pages)
        setPages(pages)
        setAutoRects(rects)
        setSignBeacons(beacons)

        setScreen("filespreview")
    } catch (error) {
        return throwErrorScreen(upload, 'catch')
    }
}

export const dspLancerStat = async (
    docId: number,
    uid: number,
    tid: number,
    type: string,
) => {
    //@ts-ignore
    const apiUrl = dspUserCallbackURL || ''
    
    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                id: docId,
                uid,
                tid,
                type,
            }),
        })
        const data = await response.json()

        if (data.status !== "success") {
            alert('Unsuccessful status response')
        }
    } catch (error) {
        alert('Unsuccessful status response')
    }
}

export const dspManualFormsUpload = async (
    upload: TUpload,
    id: number,
    rects: TSignPlacer[],
    pages: TPage[],
) => {
    const setScreen = upload.setScreen
    const req: {
        document_id: number,
        pages: TSignPlacer[][]
    } = {
        document_id: id,
        pages: [],
    }
    for (let i = 0; i < pages.length; i++) {
        req.pages.push(rects.filter(rect => rect.page === i))
    }
    // @ts-ignore
    const secret = dspHash || ''
    //@ts-ignore
    const apiUrl = dspManualFormsURL || ''
    setScreen("uploading")
    try {
        const response = await fetch(`${apiUrl}/${secret}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(req)
        })
        const data = await response.json()
        if (data.status !== "success") {
            return throwErrorScreen(upload, 'check')
        }
        setScreen("link")
    } catch (error) {
        return throwErrorScreen(upload, 'catch')
    }
}


export const localUpload = (
    upload: TUpload,
    token: string,
    byid: boolean = false
) => {
    const setScreen = upload.setScreen
    window.history.replaceState(null, '', window.location.pathname)

    setScreen("uploading")

    return sendUploadLocal(
        token,
        upload.action,
        byid ? "collection" : "local"
    ).then(data => setUploadedFiles(data, upload)
    ).catch(() => throwErrorScreen(upload, 'catch'))
}


export const onedriveUpload = (
    upload: TUpload,
    odResponse: TOneDriveResponse,
) => {
    const setScreen = upload.setScreen
    const files: TFilesOneDrive[] = []
    odResponse.value.map((file) => {
        if (validate(upload, file["name"], file["size"])) return files.push({
            url: file["@microsoft.graph.downloadUrl"],
            filename: file["name"],
            filesize: file["size"],
        })
    })

    if (files.length === 0) return false;

    setScreen("uploading")

    return sendUploadOneDrive(
        files,
        upload.setProgress,
        upload.action
    ).then(data => setUploadedFiles(data, upload)
    ).catch(() => throwErrorScreen(upload, 'catch'))
}





export const dropboxUpload = (
    upload: TUpload,
    dbResponse: TDropBoxResponse,
) => {
    const setScreen = upload.setScreen
    const files: TFilesDropBox[] = []
    dbResponse.map((file) => {
        if (validate(upload, file["name"], file["bytes"])) return files.push({
            url: file["link"],
            filename: file["name"],
            filesize: file["bytes"],
        })
    })

    if (files.length === 0) return false;

    setScreen("uploading")

    return sendUploadDropBox(
        files,
        upload.setProgress,
        upload.action
    ).then(data => setUploadedFiles(data, upload)
    ).catch(() => throwErrorScreen(upload, 'catch'))
}




export const gdriveUpload = (
    upload: TUpload,
    gdResponse: TGoogleDriveResponse,
    oauthToken: string,
) => {
    const setScreen = upload.setScreen
    const files: TFilesGoogleDrive[] = []
    gdResponse.map(file => {
        if (validate(upload, file["name"], file["sizeBytes"])) return files.push({
            g_file_id: file["id"],
            g_token: oauthToken,
            filename: file["name"],
            filesize: file["sizeBytes"],
        })
    })

    if (files.length === 0) return false;

    setScreen("uploading")

    return sendUploadGoogleDrive(
        files,
        upload.setProgress,
        upload.action
    ).then(data => setUploadedFiles(data, upload)
    ).catch(() => throwErrorScreen(upload, 'catch'))
}





export const convert = async ({
    upload,
    signs,
    signImg,
    eraseRects,
}: {
    upload: TUpload,
    signs?: TSign[],
    signImg?: string,
        eraseRects?: TErase[] | TSignPlacer[],
}) => {
    const uploadedFiles = upload.getFiles()
    const action = upload.action
    const setScreen = upload.setScreen
    const setProgress = upload.setProgress

    const pages = upload.getPages ? upload.getPages() : []

    const filesUuids: string[] = []
    uploadedFiles.map((uploadedFile) => filesUuids.push(uploadedFile.file_uuid))

    if (filesUuids.length === 0) return throwErrorScreen(upload, 'sanety')
    const data: TTaskData = { files_uuids: filesUuids }

    switch (action) {
        case 'split_pdf':
            const split_indexes: number[] = []
            let last_file_flag: number = 0
            pages.map((page, i) => {
                if (page.file_flag !== last_file_flag) {
                    split_indexes.push(i)
                    last_file_flag = page.file_flag
                }
            })

            if (split_indexes.length === 0) return throwErrorScreen(upload, 'sanety')
            data.payload = {list: split_indexes}
        break;

        case 'rearrange_pdf':
            const pgsArr: {
                page_num: number | null,
                rotate: number,
                file_uuid: string | null,
            }[] = []
            pages.map((page, i) => {
                pgsArr.push({
                    page_num: page.page_num >= 0 ? page.page_num : null,
                    rotate: page.rotate % 360,
                    file_uuid: page.file_uuid ? page.file_uuid : null,
                })
            })
            if (pgsArr.length === 0) return throwErrorScreen(upload, 'sanety')
            data.payload = {list: pgsArr}
        break;

        case 'sign_pdf':
            if (signs && signImg) { // catch err
                const maxSize = {width: 0, height: 0}
                const signsArray = signs.map(e => {
                    if (maxSize.width < e.width) {
                        maxSize.width = e.width
                        maxSize.height = e.height
                    }
                    return {
                        page: e.page,
                        meta_idx: 0,
                        rect: {
                            x0: e.x,
                            y0: e.y,
                            x1: e.x + e.width,
                            y1: e.y + e.height,
                        }
                    }
                })
                let img: string = ''
                await getPngB64(signImg, maxSize.width, maxSize.height)
                    .then(e => img = e)
                    .catch(e => { // catch err
                        console.error('getPngB64 reject!!!')
                        img = 'null'
                    })
                data.payload = { list: signsArray, meta: [img] }
            }
        break;

        case 'erase_dsp':
            if (eraseRects) { // catch err
                const rectsArray = eraseRects.map(e => ({
                    page: e.page,
                    type: e.type,
                    rect: {
                        x0: e.x,
                        y0: e.y,
                        x1: e.x + e.width,
                        y1: e.y + e.height,
                    },
                }))
                data.payload = { list: rectsArray, }
            }
            break;
    }

    setScreen("converting")

    sendTask(data, action).then(async (data: TApiTask) => {
        if (data.status !== "success" || !data.task_uuid) return throwErrorScreen(upload, 'task')
        const task_uuid = data.task_uuid
               
        let checkResponse: TApiCheck | undefined
        let checkCounter: number = 0
        while (
            checkResponse === undefined ||
            checkResponse.status === 'queue' ||
            checkResponse.status === 'pending'
        ) {
            await new Promise(r => setTimeout(r, getCheckTimeout(checkCounter)))
            checkCounter++

            checkResponse = await check(task_uuid)
            switch (checkResponse.status) {
                case 'queue':
                case 'pending':
                    setProgress(Math.round(checkResponse.progress ? checkResponse.progress : 0))
                    break
                case 'success':
                    if (checkResponse.link) {
                        upload.setDownloadLink(checkResponse.link)
                        return setScreen("link")
                    }
                    return throwErrorScreen(upload, 'check')
                default:
                    return throwErrorScreen(upload, 'check')
            } 
        }
    }).catch(() => throwErrorScreen(upload, 'catch'))

}





const prepare = async ({
    upload,
    thumb_task,
}: {
    upload: TUpload,
    thumb_task: TThumbTask,
}) => {
    const setScreen = upload.setScreen
    const setProgress = upload.setProgress
    const setPages = upload.setPages
    const setDefaultPages = upload.setDefaultPages

    // sanety
    if (!setPages || !setDefaultPages) return false

    setScreen("preparing")

    let checkResponse: TApiCheck | undefined
    let checkCounter: number = 0
    while (
        checkResponse === undefined ||
        checkResponse.status === 'queue' ||
        checkResponse.status === 'pending'
    ) {
        await new Promise(r => setTimeout(r, getCheckTimeout(checkCounter)))
        checkCounter++

        checkResponse = await check(thumb_task.thumb_task_uuid, 'gen_thumbs')

        switch (checkResponse.status) {
            case 'queue':
            case 'pending':
                setProgress(Math.round(checkResponse.progress ? checkResponse.progress : 0))
                break
            case 'success':
                if (checkResponse.pdf_pages) {
                    let pages: TPage[] = []
                    checkResponse.pdf_pages.map(page => {
                        const pageItem: TPage = {
                            page_num: page.page_num,
                            thumb_link: `${apiURL}/${page.thumb_link}`,
                            file_uuid: thumb_task.file_uuid,
                            rotate: 0,
                            file_flag: 0,
                        }
                        if (page.huge_link) pageItem.huge_link = `${apiURL}/${page.huge_link}`
                        if (page.huge_width) pageItem.originWidth = page.huge_width
                        if (page.huge_height) pageItem.originHeight = page.huge_height
                        pages.push(pageItem)
                    })

                    setDefaultPages(pages)
                    setPages(pages)
                    
                    setScreen("filespreview")
                }
                break
            default:
                return throwErrorScreen(upload, 'check')
        }
    }

}
